import { render, staticRenderFns } from "./StackedColumnChart.vue?vue&type=template&id=65e1e002"
import script from "./StackedColumnChart.vue?vue&type=script&lang=js"
export * from "./StackedColumnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports